import {
  VALID_EMAIL_REGEX,
  VALID_URL_REGEX,
} from '@funnellab/shared/src/utils/regexCollection';
import type { ValidationFunctionBasic, ValidationRule } from '../types';

export const regexFn = (regex: RegExp): ValidationFunctionBasic<string> => {
  return (value) => {
    return !value || regex.test(value);
  };
};

export const isEmail = {
  fn: regexFn(VALID_EMAIL_REGEX),
  messageKey: 'email',
} as ValidationRule<string>;

export const isUrl = {
  fn: regexFn(VALID_URL_REGEX),
  messageKey: 'invalidUrl',
} as ValidationRule<string>;
